// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const inn = defineModel({
  id: "inn",
  batchId: "future",
  name: "Inn",
  tags: ["building","inn","low-poly","age-of-mcp","future"],
  summary: "Feeds and lodges travellers — an amenity that draws trade.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.75,
  defaultVariant: "complete",
  variants: [
    { id: "stage-0", label: "Foundation", parts: () => [
      { geometry: new THREE.BoxGeometry(1.5, 0.14, 1.5), color: "#5a5a5a", position: [0, 0.07, 0] },
    ] },
    { id: "stage-1", label: "Lower", parts: () => [
      { geometry: new THREE.BoxGeometry(1.5, 0.14, 1.5), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(0.92, 0.5, 0.82), color: "#e6dcc2", position: [0, 0.39, 0] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.9, 4), color: "#6b4a26", position: [-0.6, 0.45, -0.6] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.9, 4), color: "#6b4a26", position: [0.6, 0.45, -0.6] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.9, 4), color: "#6b4a26", position: [-0.6, 0.45, 0.6] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.9, 4), color: "#6b4a26", position: [0.6, 0.45, 0.6] },
    ] },
    { id: "stage-2", label: "Upper", parts: () => [
      { geometry: new THREE.BoxGeometry(1.5, 0.14, 1.5), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(0.92, 0.62, 0.82), color: "#e6dcc2", position: [0, 0.45, 0] },
      { geometry: new THREE.BoxGeometry(1.02, 0.5, 0.92), color: "#e6dcc2", position: [0, 1.01, 0] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.5, 4), color: "#6b4a26", position: [-0.6, 0.75, -0.6] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.5, 4), color: "#6b4a26", position: [0.6, 0.75, -0.6] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.5, 4), color: "#6b4a26", position: [-0.6, 0.75, 0.6] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.5, 4), color: "#6b4a26", position: [0.6, 0.75, 0.6] },
    ] },
    { id: "complete", label: "Complete", parts: () => [
      { geometry: new THREE.BoxGeometry(1.5, 0.14, 1.5), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(0.92, 0.62, 0.82), color: "#e6dcc2", position: [0, 0.45, 0] },
      { geometry: new THREE.BoxGeometry(0.06, 0.62, 0.04), color: "#4a3520", position: [-0.43, 0.45, 0.42] },
      { geometry: new THREE.BoxGeometry(0.06, 0.62, 0.04), color: "#4a3520", position: [0.43, 0.45, 0.42] },
      { geometry: new THREE.BoxGeometry(0.92, 0.06, 0.04), color: "#4a3520", position: [0, 0.73, 0.42] },
      { geometry: new THREE.BoxGeometry(0.92, 0.06, 0.04), color: "#4a3520", position: [0, 0.17, 0.42] },
      { geometry: new THREE.BoxGeometry(0.05, 0.558, 0.04), color: "#4a3520", position: [-0.2024, 0.45, 0.42], rotation: [0, 0, 0.5] },
      { geometry: new THREE.BoxGeometry(0.05, 0.558, 0.04), color: "#4a3520", position: [0.2024, 0.45, 0.42], rotation: [0, 0, -0.5] },
      { geometry: new THREE.BoxGeometry(1.02, 0.56, 0.92), color: "#e6dcc2", position: [0, 1.04, 0] },
      { geometry: new THREE.BoxGeometry(0.06, 0.56, 0.04), color: "#4a3520", position: [-0.48, 1.04, 0.47] },
      { geometry: new THREE.BoxGeometry(0.06, 0.56, 0.04), color: "#4a3520", position: [0.48, 1.04, 0.47] },
      { geometry: new THREE.BoxGeometry(1.02, 0.06, 0.04), color: "#4a3520", position: [0, 1.29, 0.47] },
      { geometry: new THREE.BoxGeometry(1.02, 0.06, 0.04), color: "#4a3520", position: [0, 0.79, 0.47] },
      { geometry: new THREE.BoxGeometry(0.05, 0.504, 0.04), color: "#4a3520", position: [-0.2244, 1.04, 0.47], rotation: [0, 0, 0.5] },
      { geometry: new THREE.BoxGeometry(0.05, 0.504, 0.04), color: "#4a3520", position: [0.2244, 1.04, 0.47], rotation: [0, 0, -0.5] },
      { geometry: new THREE.BoxGeometry(1.04, 0.06, 0.94), color: "#4a3520", position: [0, 0.79, 0] },
      { geometry: new THREE.BoxGeometry(1.12, 0.08, 0.707107), color: "#7a4630", position: [0, 1.57, 0.25], rotation: [0.785398, 0, 0] },
      { geometry: new THREE.BoxGeometry(1.12, 0.08, 0.707107), color: "#7a4630", position: [0, 1.57, -0.25], rotation: [-0.785398, 0, 0] },
      { geometry: new THREE.BoxGeometry(1.14, 0.08, 0.08), color: "#5a3322", position: [0, 1.82, 0] },
      { geometry: new THREE.BoxGeometry(0.18, 0.7, 0.18), color: "#8d8780", position: [-0.32, 1.52, -0.3] },
      { geometry: new THREE.SphereGeometry(0.08, 6, 5), color: "#cfcabf", position: [-0.32, 1.94, -0.3] },
      { geometry: new THREE.SphereGeometry(0.1, 6, 5), color: "#dad6cc", position: [-0.3, 2.12, -0.3] },
      { geometry: new THREE.BoxGeometry(0.26, 0.44, 0.05), color: "#4a3520", position: [0, 0.36, 0.43] },
      { geometry: new THREE.BoxGeometry(0.2, 0.2, 0.04), color: "#9bb4c0", position: [0.3, 0.52, 0.43] },
      { geometry: new THREE.BoxGeometry(0.04, 0.04, 0.3), color: "#4a3520", position: [-0.5, 0.8, 0.4] },
      { geometry: new THREE.CylinderGeometry(0.01, 0.01, 0.12, 4), color: "#4a3520", position: [-0.5, 0.72, 0.54] },
      { geometry: new THREE.BoxGeometry(0.02, 0.22, 0.26), color: "#6a4a2a", position: [-0.5, 0.54, 0.54] },
      { geometry: new THREE.BoxGeometry(0.03, 0.04, 0.28), color: "#caa64a", position: [-0.5, 0.65, 0.54] },
      { geometry: new THREE.BoxGeometry(0.4, 0.05, 0.12), color: "#7a5a34", position: [0.5, 0.28, 0.6] },
      { geometry: new THREE.BoxGeometry(0.4, 0.1, 0.04), color: "#7a5a34", position: [0.5, 0.36, 0.66] },
      { geometry: new THREE.CylinderGeometry(0.1, 0.09, 0.24, 8), color: "#7a5a34", position: [0.14, 0.26, 0.62] },
    ] },
  ],
  animations: [],
});
